<template>
  <div>
    {{pgname}}
    <div class="grid-title">总分计算方式：<span>{{+project.projectpgstotalrule === 2 ? '绝对值' : '百分比'}}</span></div>
    <div class="split-line"></div>
    <vggrid :random="Math.floor(Math.random() * 999999)" ref="xGrid" :list="margeList" tableheight="600" flexname=""
            :cols="cols" :showfooter="true" :showPage="false" :resizable="true"
            :needBlackRow="false" :needPopMenu="false" :canbeEdit="false" :mergeRow='mergeRow'>
      <!--:mergeRow='mergeRow'-->
      <template slot="btn" v-if="+project.projectstatus === 10 || +project.projectstatus === 20">
        <vxe-button  icon="vxe-icon--edit-outline" v-if="expertList.length === 0"  status="perfect" @click="addForm" :loading="btnLoading">编辑评分项</vxe-button>
        <vxe-button  icon="vxe-icon--plus"  v-if="expertList.length === 0" status="perfect" @click="importExcel" :loading="btnLoading">Excel导入</vxe-button>
        <vxe-button  icon="vxe-icon--plus" v-if="expertList.length === 0" status="perfect" @click="checkScore(1)" :loading="btnLoading">检查分值</vxe-button>
        <span style="color: red;padding-left: 10px">{{alertmsg}}</span>
      </template>
    </vggrid>
    <el-dialog :close-on-click-modal="false" title="Excel导入" :visible.sync="dialogVisible" width="600px"
               :modal-append-to-body="false">
      <div class="file">
        <div>
          <upload-btn @changed='importScoreData' :text="pgname === '评审' ? '评审分导入':'技术评分项导入'"></upload-btn>
        </div>
        <div class="excel">请点击下载
          <span v-if="pgname === '评审'" @click="downloadfile">《评审分导入模板.xlsx》</span>
          <span v-if="pgname === '技术'" @click="downloadfile">《评分导入技术分导入模板.xlsx》</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../common/vggrid'
  import ProjectSetScoringFrom from './projectSetScoringFrom'
  import uploadBtn from '../common/uploadBtn.vue'

  export default {
    name: 'projectSetScoringIndex',
    props: {
      projectid: {},
      activeName: {},
      pgname: {},
      expertList: []
    },
    data () {
      return {
        btnLoading: false,
        project: {},
        margeList: [],
        list: [],
        cols: [],
        pg: {},
        alertmsg: '',
        dialogVisible: false,
        dialogType: 0,
        dialogTitle: '',
        mergeRow:['ind','pgratio','pgparentname','pgchildname']
      }
    },
    async activated () {
      await this.getModel()
      await this.getCols()
      await this.getPgTree()
      await this.getExpert()
    },
    async beforeRouteUpdate (to, from, next) {
      next()
      await this.getModel()
      await this.getCols()
      await this.getPgTree()
      await this.getExpert()
    },
    watch: {
      activeName () {
        if(this.activeName === 'pfxm_ps' || this.activeName === 'pfxm_js') {
          this.getModel()
          this.getCols()
          this.getPgTree()
          this.getExpert()
        }
      }
    },
    components: {vggrid, ProjectSetScoringFrom,uploadBtn},
    methods: {
      rlueChage () {
        // this.getCols()
      },
      async getExpert () {
        this.expertList = await request({
          url: '/xmgl/project/getPexpertList',
          method: "get",
          params: {projectid: this.$route.params.projectid}
        })
      },
      getCols () {
        if (+this.project.projectpgstotalrule === 1) {
          this.cols = [
            {field: 'pgchildname', fieldtype: 'C', title: '一级（项目）', calculExpr: '',width:200},
            {field: 'pgchildchildname', fieldtype: 'C', title: '二级（评审内容）', calculExpr: ''},
            {field: 'pgremark', fieldtype: 'C', title: '评分档次及依据', calculExpr: ''},
            {field: 'pgscore', fieldtype: 'C', title: '分值', calculExpr: '', issum: 1,width:80},
            { title: '比选人1', width: 120, showOverflow: true,
              slots: {
                default: 'default',
                default: ({row}) => {
                  return [
                    <input style="width: 100%;height: 30px;box-sizing: border-box;border-radius: 4px;border: 1px solid #DCDFE6;color: #606266;display: inline-block;padding: 0 5px;"></input>
                ]
                }
              }
            },
            { title: '比选人2', width: 120, showOverflow: true,
              slots: {
                default: 'default',
                default: ({row}) => {
                  return [
                    <input style="width: 100%;height: 30px;box-sizing: border-box;border-radius: 4px;border: 1px solid #DCDFE6;color: #606266;display: inline-block;padding: 0 5px;"></input>
                ]
                }
              }
            },
            { title: '比选人3', width: 120, showOverflow: true,
              slots: {
                default: 'default',
                default: ({row}) => {
                  return [
                    <input style="width: 100%;height: 30px;box-sizing: border-box;border-radius: 4px;border: 1px solid #DCDFE6;color: #606266;display: inline-block;padding: 0 5px;"></input>
                ]
                }
              }
            }
          ]
        } else {
          this.cols = [
            {field: 'pgchildname', fieldtype: 'C', title: '一级（项目）', calculExpr: '',width:200},
            {field: 'pgchildchildname', fieldtype: 'C', title: '二级（评审内容）', calculExpr: ''},
            {field: 'pgremark', fieldtype: 'C', title: '评分档次及依据', calculExpr: ''},
            {field: 'pgscore', fieldtype: 'C', title: '分值', calculExpr: '', issum: 1,width:80},
            { title: '比选人1', width: 120, showOverflow: true,
              slots: {
                default: 'default',
                default: ({row}) => {
                    return [
                      <input style="width: 100%;height: 30px;box-sizing: border-box;border-radius: 4px;border: 1px solid #DCDFE6;color: #606266;display: inline-block;padding: 0 5px;"></input>
                  ]
                }
              }
            },
            { title: '比选人2', width: 120, showOverflow: true,
              slots: {
                default: 'default',
                default: ({row}) => {
                    return [
                      <input style="width: 100%;height: 30px;box-sizing: border-box;border-radius: 4px;border: 1px solid #DCDFE6;color: #606266;display: inline-block;padding: 0 5px;"></input>
                  ]
                }
              }
            },
            { title: '比选人3', width: 120, showOverflow: true,
              slots: {
                default: 'default',
                default: ({row}) => {
                    return [
                      <input style="width: 100%;height: 30px;box-sizing: border-box;border-radius: 4px;border: 1px solid #DCDFE6;color: #606266;display: inline-block;padding: 0 5px;"></input>
                  ]
                }
              }
            }
          ]
        }
      },
      async getPgTree () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/pg/getPgList',
          params: {projectid: this.$route.params.projectid ? this.$route.params.projectid : this.projectid}
        })

        this.margeList = res.margelist.filter(v => v.pgparentname === this.pgname)
        this.list = res.list
        // this.checkScore()
        this.loading = false
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: '/xmgl/project/findProjectById',
          params: {projectid: this.$route.params.projectid ? this.$route.params.projectid : this.projectid}
        })
        this.project = res
      },
      addForm () {
        // this.dialogVisible = true
        this.$router.push({name: 'projectSetScoringFrom', params: {projectid: this.projectid, activeName: this.activeName}})
      },
      async checkScore (type) {
        if (this.margeList.length) {
          let scoreTotal = this.margeList.map(t => Number(t.pgscore)).reduce((a, b) => a + b)
          if (+this.project.projectpgstotalrule === 2) {
            let model = this.list.find(v => v.pgname === this.pgname)
            let pgratio = 0
            if (model) {
              pgratio =  Number(model.pgratio)
            }
            if (scoreTotal !== pgratio) {
              this.alertmsg = `当前项目总分计算方式为"绝对值"，${this.pgname}的标准分合计必须等于${pgratio}分！`
            }
          } else {
            if (scoreTotal !== 100) {
              this.alertmsg = `当前项目总分计算方式为"百分比"，${this.pgname}的标准分合计必须等于100分！`
            }
          }
          if (type) {
            if (this.alertmsg) {
              this.$message.warning(this.alertmsg)
              return
            }
            this.$message.success('分值检查通过！')
          }
        }
      },
      importExcel () {
        this.dialogVisible = true
        this.dialogType = 1
        this.dialogTitle = '导入11'
      },
      dialogClose () {
        this.dialogVisible = false
        this.dialogType = 0
      },
      downloadfile () {
        var tempwindow = window.open('_blank')
        tempwindow.location = this.excelPath
      },
      async importScoreData (path, filename){
        let data = ''
        this.loading = true
        console.log('=================margeList==================',this.margeList);
        
        if (this.margeList.length>1) {
          this.$confirm(`已经存在条目，继续导入，将删除已经存在的条目!`, '提示', {
            confirmButtonText: '继续',
            cancelButtonText: '放弃',
            type: 'warning'
          }).then(async() => {
            console.log('213')
            
            data = await request({
              url: '/xmgl/pg/importPgFromExcel',
              method: "post",
              data: {pgid: this.margeList[0].pgid,pgname:this.pgname,projectpgstotalrule: this.project.projectpgstotalrule,pgname:this.pgname,margeList:this.margeList, projectid: this.project.projectid, delflag: 1, path: path.replace(this.$store.getters.uploadAddr, 'upload/')}
            })
            if (data.issuccess === 1) {
              this.$message.success('数据导入成功')
              this.dialogClose()
              this.getCols()
              await this.getPgTree()
            } else {
              this.$message.warning(data.msg)
            }
          }).catch((e) => {
            console.log(e)
          })
        } else {
          let model = this.list.find(e=>{
            e.pgname === this.pgname
          })
          if(!model){
            model = {}
          }
          data = await request({
            url: '/xmgl/pg/importPgFromExcel',
            method: "post",
            data: {pgratio:model.pgratio,pgname:this.pgname,projectpgstotalrule: this.project.projectpgstotalrule, projectid: this.project.projectid, delflag: 0, path: path.replace(this.$store.getters.uploadAddr, 'upload/')}
          })
          if (data.issuccess === 1) {
            this.$message.success('数据导入成功')
            this.dialogClose()
            this.getCols()
            await this.getPgTree()
          } else {
            this.$message.warning(data.msg)
          }
        }
      },
      vggridClick (code, row) {
        this.$emit(code, row)
      }
    },
    computed: {
      excelPath () {
        if (this.pgname === '评审') {
          return this.$store.getters.uploadAddr + 'upload/file/评分导入评审分导入模板.xlsx'
        } else {
          return this.$store.getters.uploadAddr + 'upload/file/评分导入技术分导入模板.xlsx'
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .grid-title {
    padding-left: 20px;
    font-size: 14px;
    span {
      color: #999999;
    }
  }
  .dialog_radio {
    display: flex;
    padding-bottom: 20px;
    padding-left: 5px;
    .raido_title {
      padding-right: 20px;
    }
  }
  .file {
    display: flex;
    align-items: center;
    .excel {
      padding-left: 10px;
      span {
        color: #409EFF;
        cursor: pointer;
      }
    }
  }
</style>
